import React, { HTMLAttributes } from 'react';
import { Col, FormCheck, FormGroup } from 'react-bootstrap';
import cs from './DisableStreamingFormGroup.module.scss';

type DisableStreamingFormGroupProps = HTMLAttributes<HTMLDivElement> & {
  value: boolean,
  onChange: (value: boolean) => void
  disabled?: boolean
}

export function DisableStreamingFormGroup(props: DisableStreamingFormGroupProps) {
  const {
    value, onChange, disabled, ...rest
  } = props;

  return (
    <FormGroup as={Col} controlId="isStreamingDisabled" className={cs.formGroup}>
      <FormCheck
        custom
        name="isStreamingDisabled"
        disabled={disabled}
        checked={value}
        onChange={(e) => onChange(e.target.checked)}
        label="Disable Streaming"
        {...rest}
      />

    </FormGroup>
  );
}
